import React from 'react';
import { ArrowRight } from 'lucide-react';
import { PORTAL_BASE_URL } from '../../../utils/cn';

// The no-pressure nudge + bias disclosure. BOTH copy blocks are VERBATIM from
// the Quote Check spec (§5.8) and are counsel pre-clear items — do not reword
// here. The CTA deep-links the /r/ guest funnel entry with
// source=quote-compare attribution and the address prefilled when we know it.
//
// COPY CANON: "Service & Warranty fee" (never "platform fee"); "about 30
// minutes" (never "instant").

export function buildNudgeUrl(address) {
  const params = new URLSearchParams({ source: 'quote-compare' });
  if (address && address.trim()) params.set('address', address.trim());
  return `${PORTAL_BASE_URL}/r/address?${params.toString()}`;
}

const NudgeCard = ({ address }) => (
  <section className="relative overflow-hidden rounded-2xl bg-[#0a1628] px-5 py-8 text-white sm:px-8 sm:py-9">
    <div
      className="pointer-events-none absolute inset-0"
      aria-hidden="true"
      style={{
        background:
          'radial-gradient(ellipse 70% 80% at 50% 0%, rgba(7,176,233,0.22) 0%, transparent 65%)',
      }}
    />
    <div className="relative z-10 mx-auto max-w-xl text-center">
      <h3 className="text-xl font-extrabold tracking-tight sm:text-2xl">
        Want to see what we'd charge for the same roof?
      </h3>
      <p className="mx-auto mt-2.5 mb-6 max-w-lg text-sm leading-relaxed text-white/80">
        No pressure — type your address and we'll text and email you an exact, GAF-measured quote
        in about 30 minutes. Materials and labor at cost, every line shown, plus a flat Service
        &amp; Warranty fee. We just want you to end up with the best option — even if it isn't us.
      </p>
      <a
        href={buildNudgeUrl(address)}
        target="_blank"
        rel="noopener"
        className="inline-flex min-h-[52px] w-full items-center justify-center gap-2 rounded-xl bg-primary px-8 py-3.5 text-base font-bold text-white transition-colors duration-200 hover:bg-[#0596C7] sm:w-auto"
      >
        Get my transparent quote — FREE
        <ArrowRight size={20} aria-hidden="true" />
      </a>
      <p className="mx-auto mt-5 max-w-lg border-t border-white/15 pt-4 text-left text-[12.5px] leading-relaxed text-white/65">
        <strong className="font-bold text-white/85">Full disclosure:</strong> yes, OpenbooQ sells
        roofs too. That's exactly why we built this — we win when roof pricing is out in the open.
        Nothing in this report changes based on whether you ever buy from us.
      </p>
    </div>
  </section>
);

export default NudgeCard;
